
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/celebrities/[slugCelebrity]",
      function () {
        return require("private-next-pages/celebrities/[slugCelebrity]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/celebrities/[slugCelebrity]"])
      });
    }
  